import {RouteContext} from "../../../RouteContext";
import {Column} from "../../common/Layout";
import {ListPage} from "../../common/ListPage";
import {ShoppingParticipationPolicyIO} from "../../../../io/content/ShoppingParticipationPolicyIO";
import {
    ShoppingParticipationPolicyValueObject
} from "../../../../model/vo/content/ShoppingParticipationPolicyValueObject";



export default function List(props: RouteContext) {

    return <>
        <Column gap={'16px'}>
            <ListPage
                {...props}
                description={ShoppingParticipationPolicyValueObject.description}
                list={ShoppingParticipationPolicyIO.list}
                count={ShoppingParticipationPolicyIO.count}
                delete={ShoppingParticipationPolicyIO.delete}
                postHref={'/admin/shoppings/policies/post'}
                detailHref={item => `/admin/shoppings/policies/${item.id}`}
                editHref={item => `/admin/shoppings/policies/edit/${item.id}`}
                initialSearchConditions={[
                    {
                        name: 'deletedAt',
                        value: '',
                        condition: 'IsNull'
                    },
                ]}
            />
        </Column>
    </>
}